<app-top-bar [title]="'PAYMENT.TITLE' | translate" [customBack]="goToMenu"></app-top-bar>
@if (isLoading()) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
}

@if (lockedByOther()) {
    <div class="sync-banner">
        {{ 'PAY_AT_TABLE.SOMEONE_ELSE_PAYING' | translate }}
    </div>
}

<div class="page" data-testid="pat-page">
    @if (lines().length) {

        @if (table && chequeCode()) {
            <div class="heading">
                <h5> {{ table.table_type }} {{ table.name }} </h5>
                <h5> {{ chequeCode() }} </h5>
            </div>
        }
        <div class="line" *ngFor="let l of lines()">
            <span>{{ l.qty }} x {{ l.name }}</span>
            <span>{{ l.price | currencySpace }}</span>
        </div>

        <div class="order-total">
            <div class="line">
                <span>{{ 'PAY_AT_TABLE.CHEQUE' | translate }}</span>
                <span>{{ topOrderTotal() | currencySpace }}</span>
            </div>
            <div class="line">
                <h5>{{ 'PAY_AT_TABLE.REMAINING' | translate }}</h5>
                <h5>{{ remainingAmount() | currencySpace }}</h5>
            </div>
        </div>

        <app-voucher-form (voucherApplied)="onVoucherApplied($event)" [(hideVoucher)]="hideVoucher" [(voucher)]="voucher" />

        <app-tipping-form [total]="this.subtotal()" (tipApplied)="onTipApplied($event)" />

        <div class="line">
            @if (orderTotal() > 0) {
                <button class="btn" [class.active]="mode() === 'SPLIT'" [disabled]="lockedByOther()" (click)="onSplitBillClick()">
                    {{ splitApplied() ? 'PAY_AT_TABLE.EDIT_SPLIT' : 'PAY_AT_TABLE.SPLIT_BILL' | translate }}
                </button>
            } @else {
                <div></div>
            }
            <button class="btn" (click)="scrollToBottom()">
                {{ 'PAY_AT_TABLE.PAY_BILL' | translate }}
            </button>
        </div>

        <div class="order-summary">
            <div>
                <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
                <span>{{ (subtotal()) | currencySpace }}</span>
            </div>

            @if (fees().length) {
                @for (fee of fees(); track $index) {
                @if (fee.amount) {
                <div>
                    <span>{{ fee.name }}</span>
                    <span>{{ fee.amount | currencySpace }}</span>
                </div>
                }
                }
            } @else if (serviceFee()) {
                <div>
                    <span>{{ 'COMMON.FEES' | translate }}</span>
                    <span>{{ serviceFee() | currencySpace }}</span>
                </div>
            }

            @if (appliedPromo(); as promo) {
                @if (promo.amount) {
                <div>
                    <span>{{ 'PAY_AT_TABLE.PROMO' | translate }}</span>
                    <span>- {{ promo.amount | currencySpace }}</span>
                </div>
                }
            }

            @if (discount()) {
                <div>
                    <span>{{ 'PAY_AT_TABLE.DISCOUNT' | translate }}</span>
                    <span>- {{ discount() | currencySpace }}</span>
                </div>
            }

            @if (remainingBalance() > 0) {
                <div>
                    <span>{{ 'VOUCHER.REMAINING_BALANCE' | translate }}</span>
                    <span>{{ remainingBalance() | currencySpace }}</span>
                </div>
            }

            @if (tipAmount()) {
                <div>
                    <span>
                        {{ 'TIP.TIP' | translate }}
                    </span>
                    <span>
                        {{ tipAmount() | currencySpace }}
                    </span>
                </div>
            }

            <div>
                <span>{{ 'ORDER.TOTAL' | translate }}</span>
                <span>{{ orderTotalWithTip() | currencySpace }}</span>
            </div>
        </div>

        @if (isOrderFree()) {
            <button class="btn" [disabled]="isLoading() || lockedByOther()" type="button" (click)="processPayment()">
                {{ 'PAYMENT.PAY_CARD' | translate }}
            </button>
        } @else {
            <app-payment-options-sheet
                [paymentMethods]="paymentMethods"
                [disabled]="isLoading() || lockedByOther()"
                (optionSelected)="onPaymentOptionSelected($event)">
            </app-payment-options-sheet>
        }
    } @else {
    <div class="empty-page">
        @if (isLoading()) {
            {{ 'ACTIONS.LOADING_ORDERS' | translate }}
        } @else {
            {{ 'ACTIONS.EMPTY' | translate }}
        }
    </div>
    }
</div>

<app-loader-overlay [active]="isLoading()" />
